<!-- app.component.html -->
<div class="min-h-screen app-shell flex flex-col bg-gray-50 text-gray-900" dir="ltr">

  <!-- Row 1: Logo + Title (left aligned) -->
  <app-header></app-header>

  <!-- Row 2: Tabs menu -->
   <app-menu></app-menu>

  <!-- Row 3: Content -->
  <main class="w-full flex-1">
    <div class="w-full mx-auto px-4 sm:px-6 py-4">
      <router-outlet></router-outlet>
    </div>
  </main>

  <app-footer></app-footer>

</div>
